import { createSlice } from '@reduxjs/toolkit';

type FormState = {
  managedMachineUuid: string;
  windowFunction: string;
  windowSize: string;
};

const initialState: FormState = {
  managedMachineUuid: '',
  windowFunction: 'first',
  windowSize: '1s',
};

const slice = createSlice({
  initialState,
  name: 'form',
  reducers: {
    setManagedMachineUuid: (state, action) => {
      state.managedMachineUuid = action.payload;
    },
    setWindowFunction: (state, action) => {
      state.windowFunction = action.payload;
    },
    setWindowSize: (state, action) => {
      state.windowSize = action.payload;
    },
  },
});

const form = {
  reducer: slice.reducer,
  setManagedMachineUuid: slice.actions.setManagedMachineUuid,
  setWindowFunction: slice.actions.setWindowFunction,
  setWindowSize: slice.actions.setWindowSize,
};

export default form;
